// extracted by mini-css-extract-plugin
export default {"customModal":"HighEnergyModal_customModal__Whtb5"};